$(document).ready(function(){
$('.custom-cart .cart-fields-cart-pages').find("input:radio").prop('checked', false);
  $('.custom-cart .cart-fields-cart-pages').click(function() {
    $(this).siblings('.message-default').addClass('message-main');
var vvv = $(this).find('input[type=radio]:checked').val();
    if(vvv=='delivery'){
      $('.Delivery-options').show();
      $('.Delivery-options').find("input:radio").prop('checked', false);
    }else if(vvv=='pick-up') {
      $('.Delivery-options').hide();
      $('.Delivery-options').find("input:radio").prop('checked', false);
      $('.final-message').hide();
    }else{
    }
   $('.message-default .messaged').each(function(index,value) {
      var atdatV= $(this).attr('data-attr');  
    if (atdatV.length != 0) {
if(atdatV == vvv )
{

$(this).addClass('active');
$(this).css('display','block');
}else{
$(this).css('display','none');
$(this).removeClass('active');
}
}else{

}
});
    
  });
$('.Delivery-options .deliver-attributesoption').click(function() {
  var deliver =$(this).find('input[type=radio]:checked').val();
  if(deliver != null){
    $('.final-message').show();
  }else{
     $('.final-message').hide();
  }
});
  
});


jQuery(".cart__checkout-button.button").click(function(event) {

var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: jQuery('form[action="/cart"]').serialize(),
      dataType: 'json',
      async: false,
      };
    jQuery.ajax(params);

});